/* Material story — scroll-driven video + synced callouts.
   Pattern: sticky track, rAF-throttled progress read, video.currentTime
   slaved to scroll position, callouts cross-fade at evenly-spaced thresholds.
   Respects prefers-reduced-motion. Best-effort on iOS Safari. */
(function () {
  function init(el) {
    if (el.dataset.msInit === '1') return;
    el.dataset.msInit = '1';

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      // CSS handles the static layout in this mode. Make sure the video plays
      // muted loop so visitors still see motion.
      var v = el.querySelector('[data-ms-video]');
      if (v) { v.muted = true; v.loop = true; v.playsInline = true; v.play().catch(function () {}); }
      return;
    }

    var video = el.querySelector('[data-ms-video]');
    var callouts = Array.prototype.slice.call(el.querySelectorAll('[data-ms-callout]'));
    var heading = el.querySelector('[data-ms-heading]');
    var progressFill = el.querySelector('[data-ms-progress-fill]');
    var progressCounter = el.querySelector('[data-ms-progress-counter]');

    if (!callouts.length) return;

    var n = callouts.length;
    // Thresholds evenly spaced inside the track. Window around each is +/- (0.5/n).
    var thresholds = callouts.map(function (_, i) { return (i + 0.5) / n; });
    var halfStep = 0.5 / n;

    var videoReady = false;
    if (video) {
      video.muted = true;
      video.playsInline = true;
      // Some browsers won't expose duration without a user gesture unless we
      // attempt playback. We don't actually keep it playing.
      video.play().then(function () { video.pause(); }).catch(function () {});
      if (video.readyState >= 1) {
        videoReady = true;
      } else {
        video.addEventListener('loadedmetadata', function () { videoReady = true; }, { once: true });
      }
    }

    var isInView = false;
    var rafId = null;
    var lastProgress = -1;
    var lastActive = -1;
    var mobileMQ = window.matchMedia('(max-width: 900px)');

    function update() {
      var rect = el.getBoundingClientRect();
      var vh = window.innerHeight || document.documentElement.clientHeight;
      var trackHeight = rect.height - vh;
      var p = trackHeight > 0 ? (-rect.top) / trackHeight : 0;
      if (p < 0) p = 0; else if (p > 1) p = 1;

      if (Math.abs(p - lastProgress) > 0.0005) {
        lastProgress = p;

        // Video scrub. Avoid sub-frame thrashing AND avoid reaching exactly
        // duration: once the video hits its end, browsers (esp. iOS Safari)
        // mark it ended and resist redrawing when you seek backward. Cap the
        // target at duration - 0.05s and explicitly pause before each seek.
        if (video && videoReady && isFinite(video.duration) && video.duration > 0) {
          var t = video.duration * p;
          if (t > video.duration - 0.05) t = video.duration - 0.05;
          if (t < 0) t = 0;
          if (Math.abs(video.currentTime - t) > 0.033) {
            try {
              if (!video.paused) video.pause();
              video.currentTime = t;
            } catch (e) { /* iOS quirks */ }
          }
        }

        // Find active callout: nearest threshold within window.
        var activeIndex = -1;
        var bestDist = Infinity;
        for (var i = 0; i < n; i++) {
          var d = Math.abs(p - thresholds[i]);
          if (d <= halfStep && d < bestDist) { bestDist = d; activeIndex = i; }
        }
        if (activeIndex !== lastActive) {
          for (var j = 0; j < n; j++) {
            callouts[j].dataset.active = (j === activeIndex) ? 'true' : 'false';
          }
          lastActive = activeIndex;
        }

        if (heading) heading.dataset.fade = (p > 0.025) ? 'true' : 'false';

        if (progressFill) {
          progressFill.style.transform = mobileMQ.matches
            ? 'scaleX(' + p.toFixed(4) + ')'
            : 'scaleY(' + p.toFixed(4) + ')';
        }
        if (progressCounter) {
          var step = Math.min(n, Math.max(1, Math.ceil(p * n) || 1));
          var pad = function (x) { return (x < 10 ? '0' : '') + x; };
          progressCounter.textContent = pad(step) + ' / ' + pad(n);
        }
      }

      if (isInView) rafId = requestAnimationFrame(update);
      else rafId = null;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        isInView = entry.isIntersecting;
        if (isInView && rafId === null) {
          rafId = requestAnimationFrame(update);
        } else if (!isInView && rafId !== null) {
          cancelAnimationFrame(rafId);
          rafId = null;
        }
      });
    }, { threshold: 0, rootMargin: '0px' });
    io.observe(el);
  }

  function bootstrap(root) {
    (root || document).querySelectorAll('[data-material-story]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { bootstrap(); });
  } else {
    bootstrap();
  }
  // Theme editor: rebind on section reload
  document.addEventListener('shopify:section:load', function (e) {
    if (e && e.target) bootstrap(e.target);
  });
})();
